import { getConfigOptions } from './getConfig'
import { useMutation, useQueryClient, type MutationFunction } from '@tanstack/react-query'
import type { MutationConfig } from '@/shared/utils/reactQuery'
import type { OidcClientConfig } from '../types/authTypes'
import { config as appConfig } from '@/config'

type LoginRedirectProps = {
  config: OidcClientConfig
}

const loginRedirect = ({ config }: LoginRedirectProps) => {
  const authUrl = new URL(config.authorization_endpoint)
  const authParams = new URLSearchParams({
    response_type: 'code',
    client_id: appConfig.auth.clientId,
    redirect_uri: appConfig.auth.loginRedirectUri,
    scope: 'openid profile email',
  })
  authUrl.search = authParams.toString()
  window.location.href = authUrl.toString()
}

type UseLoginCallbackProps = {
  mutationConfig?: MutationConfig<MutationFunction<void, void>>
}

const useLoginRedirect = ({ mutationConfig }: UseLoginCallbackProps = {}) => {
  const { ...restConfig } = mutationConfig || {}
  const queryClient = useQueryClient()

  return useMutation({
    ...restConfig,
    meta: { silent: true },
    mutationFn: async () => {
      const configQuery = getConfigOptions()
      const config = queryClient.getQueryData(configQuery.queryKey) ?? (await queryClient.fetchQuery(configQuery))
      loginRedirect({ config })
    },
  })
}

export { loginRedirect, useLoginRedirect }
